export type Topic = {
    name: string,
}

export const mqttSicherungen: Topic = {
    name: 'nexus/sicherungen',
}

export const mqttNumpad: Topic = {
    name: 'nexus/numpad',
}

export const mqttVentil: Topic = {
    name: 'nexus/ventil',
}

export const mqttVentilDiff: Topic = {
    name: 'nexus/ventil-diff',
}

export const mqttSprache: Topic = {
    name: 'nexus/sprache',
}

export const mqttInputMode: Topic = {
    name: 'nexus/input-mode',
}

export const mqttStep: Topic = {
    name: 'nexus/step',
}

export const mqttJetztSchluss: Topic = {
    name: 'nexus/jetzt-schluss',
}

export const mqttCmd: Topic = {
    name: 'nexus/cmd',
}

export const mqttExtJetztSchluss: Topic = {
    name: '0004/waldraetsel/jetzt-schluss',
}

export const mqttExtStep: Topic = {
    name: '0004/waldraetsel/step',
}

export const mqttExtCmd: Topic = {
    name: '0004/waldraetsel/cmd',
}

export const mqttExtStatus: Topic = {
    name: '0004/waldraetsel/status',
}

export const mqttExtSprache: Topic = {
    name: '0004/waldraetsel/sprache',
}

export const mqttExtSicherungen: Topic = {
    name: '0004/waldraetsel/status/sicherungen',
}
